import React, { useState, useEffect } from 'react'

interface InterfaceSources {
  sources: {
    Hinweise: string
    Kanton: string
    Links: [string, [{ link: string; linktext: string }]]
    Quelle: string
    Stand: string
  }[]
  locales: {
    title: string
    tableKey: string[]
  }
}
interface InterfaceSource {
  Kanton: string
  Quelle: string
  Links: [
    string,
    {
      link: string
      linktext: string
    }[]
  ]
  Stand: string
}
export const Sources = ({ sources, locales }: InterfaceSources) => {
  // console.log(sources)
  const [visible, toggle] = useState(false)
  const [stateSources, updateSources] = useState<InterfaceSource | undefined>(
    undefined
  )
  const readLinks = (str: string) => {
    var ret: [string, { link: string; linktext: string }] = []
    var matches = str.match(/\[(.*?)\]|\((.*?)\)/g)
    if (matches) {
      matches.forEach((e, i) => {
        str = str.replace(e, '')
        if (i % 2 === 1)
          ret.push({
            link: e.replace('(', '').replace(')', ''),
            linktext: matches[i - 1].replace('[', '').replace(']', '')
          })
      })
    }
    return [str, ret]
  }
  useEffect(() => {
    const newSources = sources.map(source => {
      delete source['']
      source.Links = readLinks(source.Quelle)
      return source
    })
    updateSources(newSources)
  }, [])
  const toggleContent = () => {
    toggle(!visible)
  }

  return (
    <div className='sources'>
      <div className={visible ? 'title open' : 'title'} onClick={toggleContent}>
        {locales.title}
      </div>
      {visible && (
        <div className='content'>
          <table>
            <thead>
              <tr>
                <td className='kanton'>{locales.tableKey[0]}</td>
                <td className='source'>{locales.tableKey[1]}</td>
                <td className='stand'>{locales.tableKey[2]}</td>
              </tr>
            </thead>
            <tbody>
              {stateSources.map((source: InterfaceSource, i: number) => {
                const links = source.Links
                return (
                  <tr key={i.toString()}>
                    <td className='kanton'>{source.Kanton}</td>
                    <td className='source'>
                      {links[1].length > 0 && (
                        <div key={i.toString()}>
                          {links[0].length > 0 ? links[0].trim() + ', ' : ''}
                          {links[1].map((e, i) => {
                            return (
                              <a href={e.link} key={i} target='blank'>
                                {i + 1 < links[1].length
                                  ? e.linktext + ', '
                                  : e.linktext}
                              </a>
                            )
                          })}
                        </div>
                      )}
                      {links[1].length === 0 && <div>{links[0]}</div>}
                    </td>
                    <td className='stand'>{source.Stand}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
